export interface SocialMedia {
    name: string
    username: string
    url: string
    followers: number
}

export enum SUPPORTED_SOCIAL_MEDIAS_ENUM {
    instagram = 'instagram',
    facebook = 'facebook',
    twitter = 'twitter',
    youtube = 'youtube',
    tiktok = 'tiktok',
    twitch = 'twitch',
    telegram = 'telegram',
    whatsapp = 'whatsapp',
    linkedin = 'linkedin',
}

export type SUPPORTED_SOCIAL_MEDIAS = keyof typeof SUPPORTED_SOCIAL_MEDIAS_ENUM;
